import {instance} from "./";

export const getFacilitiesList = () => {
  return instance({
    method: "get",
    url: "/work/api/building"
  });
};

export const getFacilityCard = id => {
  return instance({
    method: "get",
    url: `/work/api/building/${id}/card`
  });
};

export const getFacilityFullInfo = id => {
  return instance({
    method: "get",
    url: `/work/api/building/${id}`
  });
};

export const createFacility = data => {
  return instance({
    method: "post",
    url: `/work/api/building/`,
    data
  });
};

export const updateFacility = (id, main) => {
  return instance({
    method: "post",
    url: `/work/api/building/${id}`,
    data: {
      main,
    }
  });
};

export const deleteFacility = id => {
  return instance({
    method: "delete",
    url: `/work/api/building/${id}`
  });
};

export const getOrganizationsList = () => {
  return instance({
    method: "get",
    url: "/work/api/organization?mode=select"
  });
};

export const getMunicipalsList = (region) => {
  return instance({
    method: "get",
    url: `/work/api/dict/municipal?regionId=${region}`
  });
};

export const getFacilityDepartments = id => {
  return instance({
    method: "get",
    url: `/work/api/building/${id}/main/department`
  });
};

export const addFacilityDepartment = (id, depId) => {
  return instance({
    method: "post",
    url: `/work/api/building/${id}/main/department`,
    data: {
      departmentId: depId,
    }
  });
};

export const deleteFacilityDepartment = (id, depId) => {
  return instance({
    method: "delete",
    url: `/work/api/building/${id}/main/department/${depId}`,
  });
};

export const addFacilityImage = (id, image) => {
  const data = new FormData();
  data.set('photo', image);

  return instance({
    method: "post",
    url: `/work/api/building/${id}/main/photo/`,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data,
  });
}

export const deleteFacilityPhoto = (facilityId, fileId) => {
  return instance({
    method: "delete",
    url: `/work/api/building/${facilityId}/main/photo/${fileId}`
  });
}

export default {
  getFacilitiesList,
  getFacilityCard,
  createFacility,
  deleteFacility,
  getOrganizationsList,
  getMunicipalsList,
  getFacilityFullInfo,
  updateFacility,
  getFacilityDepartments,
  addFacilityDepartment,
  deleteFacilityDepartment,
  addFacilityImage,
  deleteFacilityPhoto
};
